import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Box } from '@hub/box';
import { Stack } from '@hub/stack';
import { CoreContainer } from '@hub/core-container';
import { useToken } from '@hub/design-system-base';
import { useCountryContext } from '../../../context';
import { CentreSelector as SharedCentreSelector, getCentreDisplayTitle, MAX_SUGGESTIONS } from '../../../components/centre-selector';
import { useRecentCentres } from '../../../hooks/use-recent-centres';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { Country } from '../../../../types/country';
import { VisitCentreTabPanel } from './visit-centre-tab-panel';
import navStyle from './navStyle.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const centreSelectorConfig = {
  allCentresLabel: 'All centres',
  inputLabel: '',
  locationLabel: 'Or use your current location',
  suggestedCentresLabel: 'Suggested Centres',
  id: 'header-centre-selector'
};
export const FindACentreNavPanel = _ref => {
  let {
    centres,
    centre: currentCentre
  } = _ref;
  const country = useCountryContext();
  const menuZIndex = useToken('zIndices', 'menu');
  const {
    0: isOpenCentre,
    1: setIsOpenCentre
  } = useState(country === Country.Australia);
  const toggleOpenCentre = useCallback(() => {
    const navAction = isOpenCentre ? analyticsUtils.actions.UNIVERSAL_HEADER_NAV_CLOSE : analyticsUtils.actions.UNIVERSAL_HEADER_NAV_OPEN;
    setIsOpenCentre(!isOpenCentre);
    trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, navAction, "Find a centre ".concat(isOpenCentre ? 'close' : 'open'));
  }, [isOpenCentre]); // Inject a `.displayTitle` field for better rendering

  const centresWithDisplayTitle = useMemo(() => // something's gone wrong with our type checking
  // for the following ?? [] to be needed:
  (centres !== null && centres !== void 0 ? centres : []).map(centre => _objectSpread(_objectSpread({}, centre), {}, {
    displayTitle: getCentreDisplayTitle(centre)
  })), [centres]);
  const recentCentres = useRecentCentres();
  const {
    0: suggestedCentres,
    1: setSuggestedCentres
  } = useState([]);
  useEffect(() => {
    setSuggestedCentres(centresWithoutCurrent(currentCentre, recentCentres, centresWithDisplayTitle));
  }, [currentCentre, recentCentres, centresWithDisplayTitle]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CoreContainer, {
      fadeOutOverflow: true,
      as: Stack,
      direction: "row",
      align: "center",
      shouldWrapChildren: false,
      sx: {
        height: 'size-full',
        fontSize: 'font-sm',
        overflowX: 'scroll',
        position: 'relative',

        /* Hide scrollbar for Chrome, Safari and Opera */
        '&::-webkit-scrollbar': {
          display: 'none'
        },

        /* Hide scrollbar for IE, Edge and Firefox */
        msOverflowStyle: 'none'
        /* IE and Edge */
        ,
        scrollbarWidth: 'none'
        /* Firefox */
        ,
        zIndex: menuZIndex
      },
      "data-id": "tabs_find-a-centre-panel_FindACentreNavPanel_CoreContainer",
      children: /*#__PURE__*/_jsx(VisitCentreTabPanel, {
        suggestedCentres: suggestedCentres,
        toggleOpenCentre: toggleOpenCentre,
        isOpenCentre: isOpenCentre,
        "data-id": "tabs_find-a-centre-panel_FindACentreNavPanel_CoreContainer_VisitCentreTabPanel"
      }, "visit-centre")
    }), isOpenCentre && /*#__PURE__*/_jsx(Box, {
      sx: {
        bg: 'white',
        position: 'relative',
        zIndex: 'dropdown',
        boxShadow: '0px 16px 16px 0px rgba(0,0,0,0.15)'
      },
      "data-id": "tabs_find-a-centre-panel_FindACentreNavPanel_Box",
      children: /*#__PURE__*/_jsx(CoreContainer, {
        "data-id": "tabs_find-a-centre-panel_FindACentreNavPanel_Box_CoreContainer",
        children: /*#__PURE__*/_jsx(SharedCentreSelector, {
          callBackSetSuggestedCentres: setSuggestedCentres,
          centres: centres,
          navStyle: navStyle,
          config: centreSelectorConfig,
          "data-id": "tabs_find-a-centre-panel_FindACentreNavPanel_CoreContainer_SharedCentreSelector"
        })
      })
    })]
  });
};

function centresWithoutCurrent(currentCentre, recentCentres, centresWithDisplayTitle) {
  // Filter out the current centre from suggestions
  const filteredSlugs = currentCentre ? recentCentres.filter(slug => slug !== currentCentre.slug) : recentCentres;
  return filteredSlugs // Convert it into a complete object
  .map(slug => centresWithDisplayTitle.find(centre => centre.slug === slug)) // Clear out any bad data
  .filter(centre => Boolean(centre)) // Limit the number of suggestions we return
  .slice(0, MAX_SUGGESTIONS);
}